import React from 'react'
import { ImSpinner2 } from 'react-icons/im'
import "./loader.css"

const Loader = ({size}) => {
  return <ImSpinner2 className="loader--spinning" size={size}/>
}

export default Loader